import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters";

export default {
  namespaced: true,
  state: () => ({
    addOrUpdateSessionDialog: false,
    viewSessionDialog: false,
    reportSessionDialog: false,
  }),
  mutations,
  actions,
  getters,
};
